export const requestStateEnum = {
  SUCCESS: 'request_state_success',
  IN_PROGRESS: 'request_state_in_progress',
  ERROR: 'request_state_error',
  NOT_SENT: 'request_state_not_sent'
}
